import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { SharedService } from '../../../services/shared.service';
import { io, Socket } from 'socket.io-client';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
@Component({
  selector: 'app-employee-attendance',
  standalone: false,
  templateUrl: './employee-attendance.component.html',
  styleUrl: './employee-attendance.component.css'
})
export class EmployeeAttendanceComponent {
  @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;
  @ViewChild('videoQRElement') videoQRElement!: ElementRef<HTMLVideoElement>;
  @ViewChild('canvasElement') canvasElement!: ElementRef<HTMLCanvasElement>;

  public socket: Socket;
  video!: HTMLVideoElement;
  canvas!: HTMLCanvasElement;
  isModelLoaded = false;
  isCameraStarted = false;
  filterForm!: FormGroup;
  attendanceRecords: any[] = [];
  recognizedFaces: any[] = [];
  window: Window = window;
  shareObject: any = {
    isLoading: false,
    options: {},
    employees: [],
    currentDate: new Date(),
    daysArray: [],
    monthNames: ['Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6',
      'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'],
  };
  constructor(
    public sharedService: SharedService,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private form: FormBuilder,
    private router: Router,
  ) {
    this.socket = io(new URL(this.sharedService.env.apiUrl).origin, {
      auth: { token: this.sharedService.token, },
      transports: ['websocket', 'polling'],
    });
    // this.shareObject.daysInMonth = this.getDaysInMonth(this.shareObject.currentDate.getFullYear(), this.shareObject.currentDate.getMonth() + 1);
    // this.shareObject.daysArray = Array.from({ length: this.shareObject.daysInMonth }, (_, i) => i + 1);
  }
  downloadHtml() {
    const element = document.getElementById('attendance-list');
    if (!element) return;
    //xóa nội dung của element có id là btns nằm trong element
    const btns = element.querySelector('#btns');
    if (btns) {
      btns.classList.add('d-none');
    }

    // dump all stylesheets
    const styleSheets = Array.from(document.styleSheets).map((styleSheet: any) => {
      try {
        return Array.from(styleSheet.cssRules).map((rule: any) => rule.cssText).join('\n');
      } catch (e) {
        return '';
      }
    }).join('\n');
    const htmlContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <title>Attendance List</title>
      <style>
        ${styleSheets}
        </style>
    </head>
    <body>
      ${element.outerHTML}
    </body>
    </html>
  `;

    const blob = new Blob([htmlContent], { type: 'text/html' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `report_attendance_${new Date(this.shareObject.options.startDate).toLocaleDateString()}_${new Date(this.shareObject.options.endDate).toLocaleDateString()}`.toUpperCase();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
    // thêm lại nội dung của element có id là btns vào element
    if (btns) {
      btns.classList.remove('d-none');
    }
  }


  getDaysInMonth(year: number, month: number): number {
    return new Date(year, month, 0).getDate();
  }

  getCurrentMonthYear(): string {
    return `${this.shareObject.monthNames[this.shareObject.currentDate.getMonth()]} ${this.shareObject.currentDate.getFullYear()}`;
  }
  onSearch() {
    const now = new Date();
    const lastMonth = new Date(now.setMonth(now.getMonth() - 1));
    lastMonth.setHours(0, 0, 0, 0);
    this.shareObject.options.startDate = new Date(this.filterForm.value.startDate);
    this.shareObject.options.endDate = new Date(new Date(this.filterForm.value.endDate).setHours(23, 59, 59, 999));
    this.shareObject.options.keyword = this.filterForm.value['keyword'] ?? undefined;
    this.shareObject.options.page = 1;
    this.shareObject.options.employeeGroup = this.filterForm.value['employeeGroup'] ?? undefined;
    this.shareObject.options.limit = this.filterForm.value['limit'] ?? this.sharedService.env.pageSize[0];
    if (this.shareObject.options.employeeGroup && this.shareObject.data.type != 'report') {
      this.shareObject.groupName = this.shareObject.employeeGroupList.find((item: any) => item.id === this.shareObject.options.employeeGroup)?.name;
    }
    this.getItems();
  }
  employeeGroupList() {
    this.sharedService.callApi(`/employee_group/list`, {}).subscribe((res: any) => {
      if (res.success) {
        this.shareObject.employeeGroupList = res.data.data;
      }
    });
  }
  filter(key: any, value: any) {
    this.filterForm.patchValue({
      [key]: value
    });
    this.shareObject.options.page = 1;
    this.onSearch();
  }
  async ngOnInit() {
    this.socket.on('attendance.getcode', (data: any) => {
      let { hash, expiredTime } = data;
      if (hash) {
        let stationId = this.sharedService.user?.id || '';
        this.sharedService.generatorQRCode([hash, stationId].join(`.`)).then((res: any) => {
          this.shareObject.qrCode = res.qrImage;
        });
        if (this.shareObject.qrInterval) {
          clearInterval(this.shareObject.qrInterval);
        }
        this.shareObject.qrInterval = setInterval(() => {
          this.shareObject.countdown = expiredTime = expiredTime - 1;
          if (this.shareObject.countdown <= 0) {
            clearInterval(this.shareObject.qrInterval);
            this.getQrCodeText();
          }
        }, 1000);
      }
    });
    this.shareObject.data = this.activatedRoute.snapshot.data;
    if (this.shareObject.data.type == 'attendance-faceid-station') {
      this.listFaceids();
    } else if (this.shareObject.data.type == 'history') {
      this.getListAttendance();
    }
    else if (this.shareObject.data.type == 'list' || this.shareObject.data.type == 'report') {
      this.filterForm = this.form.group({
        limit: [this.sharedService.env.pageSize[0]],
        startDate: [new Date(new Date().setDate(1)).toISOString().slice(0, 10)],
        endDate: [new Date().toISOString().slice(0, 10)],
        keyword: [''],
        employeeGroup: [''],
      });
      this.activatedRoute.queryParams.subscribe((params: any) => {
        if (params['employeeId']) {
          this.shareObject.options.user = params['employeeId'];
        }
        if (params['group']) {
          this.filterForm.patchValue({
            employeeGroup: params['group']
          });
        }
      });
      this.shareObject.isLoading = true;
      this.employeeGroupList();
      this.onSearch();
      console.log('this.shareObject.data:', this.shareObject.data);
      this.filterForm.patchValue({
        limit: this.sharedService.env.pageSize[0],
      });
    } else {
      this.getFaceId();
      this.getQrCodeText();
    }
  }
  getItems() {
    this.shareObject.filterBox = false;
    this.shareObject.isLoading = true;
    this.sharedService.callApi(`/employee_attendance/list_attendance`, this.shareObject.options).subscribe({
      next: (res: any) => {
        this.shareObject.employees = res.data.data;
        this.shareObject.daysArray = Object.keys(res.data.data[0].attendances);
        if (this.shareObject.data.type == 'report') {
          this.pieChart(res.data.data[0]);
          const data: any = res.data.data[0].attendances;
          this.shareObject.userAttendance = res.data.data[0];
          const result = Object.entries(data)
            .filter(([_, records]: any) => records.length > 0) // 🧹 Bỏ ngày không có dữ liệu
            .map(([date, records]: any) => {
              const summary: any = {
                date,
                checkin_miss: 0,
                checkin_match: 0,
                checkin_early: 0,
                checkin_late: 0,
                checkout_miss: 0,
                checkout_match: 0,
                checkout_early: 0,
                checkout_late: 0,
              };
              for (const { type, status } of records) {
                const key = `${type}_${status}`;
                if (key in summary) {
                  summary[key]++;
                }
              }

              return summary;
            });
          this.shareObject.attendanceRecords = result;
        }
      },
      error: (error: any) => {
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: this.translate.instant('toast_cant_get_data'),
          type: 'error'
        })
      },
      complete: () => {
        this.shareObject.isLoading = false;
      }
    })
  }
  getQrCodeText() {
    if (this.socket) {
      this.socket.emit('attendance.getcode');
    } else {
      this.sharedService.callApi(`/employee_attendance/generate_qrcode_text`, {}).subscribe((r: any) => {
        if (r && r.data) {
          this.sharedService.generatorQRCode(r.data.qrcode).then((res: any) => {
            this.shareObject.qrCode = res.qrImage;
          });
          this.shareObject.qrCodeText = r.data.qrCodeText;
        }
      });
    }
  }
  clickScanQR() {
    this.sharedService.qrScan().then((data: any) => {
      if (data) {
        this.attendanceByQrcode(data);
      }
    });
  }
  clickScanID() {
    this.sharedService.idScan(this.shareObject.faceId).then((res: any) => {
      if (res && res === true) {
        this.attendanceByFaceId();
      }
    });
  }
  clickScanIDs() {
    this.sharedService.idScans(this.shareObject.faceIds).then((res: any) => {

    });
  }
  //list attendance 
  getListAttendance() {
    this.shareObject.isLoading = true;
    this.sharedService.callApi(`/employee_attendance/list`, { limit: this.sharedService.env.pageSize[0] }).subscribe((res: any) => {
      if (res.success) {
        this.shareObject.attendanceRecords = res.data.data;
        this.shareObject.isLoading = false;
        console.log('attendanceRecords:', this.shareObject.attendanceRecords);
      } else {
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: this.translate.instant('toast_cant_get_data'),
          type: 'error'
        })

      }
    });
  }
  attendanceByFaceId() {
    this.sharedService.callApi(`/employee_attendance/attendance_by_face_id`, {}).subscribe({
      next: (res: any) => {
        console.log('user_attendence:', res);
        if (res.success) {
          this.shareObject.checkinSuccess = true;
          this.sharedService.toast({
            title: 'Thành công',
            message: 'Điểm danh thành công',
            type: 'success'
          })
          this.router.navigate(['/user/profile'])
        } else {
          this.sharedService.toast({
            title: 'Thất bại',
            message: 'Điểm danh thất bại',
            type: 'error'
          })
        }
      },
      error: (error: any) => {
        this.sharedService.toast({
          title: 'Thất bại',
          message: error.message,
          type: 'error'
        })
        console.error('Error during attendance:', error);
      }
    });
  }
  attendanceByQrcode(qrcode: any = null) {
    this.sharedService.callApi(`/employee_attendance/attendance_by_qrcode`, { qrhash: qrcode }).subscribe({
      next: (res: any) => {
        console.log('user_attendence:', res);
        if (res.success) {
          this.shareObject.checkinSuccess = true;
          this.sharedService.toast({
            title: 'Thành công',
            message: 'Điểm danh thành công',
            type: 'success'
          })
          this.router.navigate(['/user/profile'])
        } else {
          this.sharedService.toast({
            title: 'Thất bại',
            message: 'Điểm danh thất bại',
            type: 'error'
          })
        }
      },
      error: (error: any) => {
        this.sharedService.toast({
          title: 'Thất bại',
          message: error.message,
          type: 'error'
        })
        console.error('Error during attendance:', error);
      }
    });
  }
  ngOnDestroy() {
    if (this.shareObject.timerSubscription) {
      this.shareObject.timerSubscription.unsubscribe();
    }
    if (this.shareObject.countdownInterval) {
      clearInterval(this.shareObject.countdownInterval);
    }
    this.socket.off('attendance.get-code');
  }
  async getFaceIdBak() {
    this.sharedService.callApi(`/users/profile`, {}).subscribe((response: any) => {
      console.log('getFaceId:', response);
      if (response && response.data) {
        this.shareObject.faceId = response.data.profile.faceId;
        // this.idScan(this.shareObject.faceId).then((res: any) => {
        //   console.log('idScan:', res);
        // });
      }
    });
  }
  async getFaceId() {
    this.sharedService.callApi(`/employee_face/get_me`, {}).subscribe((response: any) => {
      console.log('getFaceId:', response);
      if (response && response.data) {
        this.shareObject.faceId = response.data.faceId;
        // this.idScan(this.shareObject.faceId).then((res: any) => {
        //   console.log('idScan:', res);
        // });
      }
    });
  }
  async addFaceId(id: any = null) {
    this.sharedService.idScan().then((faceId: any) => {
      this.sharedService.callApi(`/users/add_face_id`, { id, faceId }).subscribe((response: any) => {
        console.log('user_add_face_id:', response);
        if (response && response.data) {
          this.sharedService.toast({
            title: 'Thành công',
            message: 'Thêm khuôn mặt thành công',
            type: 'success'
          })
        } else {
          this.sharedService.toast({
            title: 'Thất bại',
            message: 'Thêm khuôn mặt thất bại',
            type: 'error'
          })
        }
      });
    }).catch((err: any) => {
      this.sharedService.toast({
        title: 'Thất bại',
        message: 'Không tìm thấy khuôn mặt',
        type: 'error'
      })
      return;
    });
  }
  async capture() {
    this.sharedService.idScan().then((res: any) => {
      if (!res || res === null) {
        this.sharedService.toast({
          title: 'Thất bại',
          message: 'Không tìm thấy khuôn mặt',
          type: 'error'
        })
        return;
      }
      this.sharedService.callApi(`/users/profile_update`, { profile: { faceId: res } }).subscribe((response: any) => {
        this.getFaceId();
        console.log('user_add_face_id:', response);
      });
    });
  }
  rotateCamera(type: any = null) {
    if (type) {
      this.shareObject.camType = type;
      this.shareObject.qrScanner.setCamera(type);
    } else {
      this.shareObject.camType = this.shareObject.camType === 'user' ? 'environment' : 'user';
      this.shareObject.qrScanner.setCamera(this.shareObject.camType);
    }
  }
  pieChart(data: any) {
    this.shareObject.pieCtx = document.getElementById('pieChart') as HTMLCanvasElement;
    if (this.shareObject.pieChart) {
      this.shareObject.pieChart.destroy();
    }
    this.shareObject.pieChart = null;
    let totalType: any = {
      cheackin_early: data.totalCheckinEarly,
      cheackin_late: data.totalCheckinLate,
      cheackin_match: data.totalCheckinMatch,
      cheackin_miss: data.totalCheckinMiss,
      checkout_early: data.totalCheckoutEarly,
      checkout_late: data.totalCheckoutLate,
      checkout_match: data.totalCheckoutMatch,
      checkout_miss: data.totalCheckoutMiss,
    };
    let colorType: any = {
      cheackin_early: '#bdc3c7',
      cheackin_late: '#2ecc71',
      cheackin_match: '#4bc0c0',
      cheackin_miss: '#e74c3c',
      checkout_early: '#9b59b6',
      checkout_late: '#ffcd56',
      checkout_match: '#ff6384',
      checkout_miss: '#2c3e50',
    };
    let totalTypeArr = Object.keys(totalType).map((key: any) => {
      return {
        type: key,
        color: colorType[key],
        count: totalType[key]
      }
    }).filter((item: any) => item.count > 0);
    this.shareObject.pieChart = new Chart(this.shareObject.pieCtx, {
      type: 'pie',
      data: {
        labels: totalTypeArr.map((item: any) => {
          return this.translate.instant(item.type) + ` (${item.count})`;
        }),
        datasets: [{
          label: data.profile.name,
          data: totalTypeArr.map((item: any) => item.count),
          backgroundColor: totalTypeArr.map((item: any) => item.color),
          borderColor: totalTypeArr.map((item: any) => item.color),
          borderWidth: 1
        }]
      },
      options: {
        responsive: false,
        plugins: {
          tooltip: {
            callbacks: {
              label: function (context: any) {
                let value = parseInt(context?.raw) || 0;
                let total = parseInt(context.dataset.data.reduce((a: any, b: any) => a + b, 0));
                let percentage = Math.round((value / total) * 100);
                return `${value} (${percentage}%)`;
              }
            }
          },
          //sửa width mà khong làm ảnh hưởng đến height

          legend: {
            display: true,
            position: 'right',
          },
          datalabels: {
            formatter: (value, context: any) => {
              let total = parseInt(context.dataset.data.reduce((a: any, b: any) => a + b, 0));
              let percentage = Math.round((value / total) * 100);
              return `${value} (${percentage}%)`;
            },
            color: '#fff',
            font: {
              weight: 'bold',
              size: 14
            }
          }
        }
      },
      plugins: [ChartDataLabels]
    });
    this.shareObject.pieChart.update();
  }
  print() {
    this.window.print();
  }
  listFaceids() {
    this.sharedService.callApi(`/employee_face/list`, {}).subscribe((res: any) => {
      if (res.success) {
        this.shareObject.faceIds = res.data.data;
        this.sharedService.idScans(this.shareObject.faceIds).then((res: any) => {

        });
        console.log('faceIds:', this.shareObject.faceIds);
      } else {
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: this.translate.instant('toast_cant_get_data'),
          type: 'error'
        })
      }
    });
  }
  // khi có hotkey esc thì dừng camera
  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(event: KeyboardEvent) {
    let videos = document.querySelectorAll('video');
    videos.forEach((video: any) => {
      video.pause();
      video.srcObject = null;
      video.parentElement.remove();
    })
  }
  getSocketInstance(): Socket {
    return this.shareObject.socket;
  }
}
